module.exports = __webpack_public_path__ + "static/img/pic-homepage-cooperation2.c7cdcf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pic-homepage-cooperation2.png
// module id = 1013
// module chunks = 0